import { combineReducers } from 'redux'
import SignInReducer from './components/screens/sign-in/sign-in-redux/sing-in.reducer'
import ForgotPasswordReducer from './components/screens/forgot-password/redux/forgot-password.reducer'
import MagicLinksReducer from './components/screens/magic-links/redux/magic-links.reducer'
import AcceptTCReducer from './components/screens/finish-signup/screens/terms-and-conditions/redux/terms-and-conditions.reducer'
import FSUTeacherReducer from './components/screens/finish-signup/screens/fsu-teacher/redux/fsu-teacher.reducer'
import FSUEmailRequiredReducer from './components/screens/finish-signup/screens/email-required/redux/email-required.reducer'
import FSUPasswordRequiredReducer from './components/screens/finish-signup/screens/password-required/redux/password-required.reducer'

const Reducer = combineReducers({
  SignIn: SignInReducer,
  MagicLinks: MagicLinksReducer,
  ForgotPassword: ForgotPasswordReducer,
  AcceptTC: AcceptTCReducer,
  FSUTeacher: FSUTeacherReducer,
  FSUEmailRequired: FSUEmailRequiredReducer,
  FSUPasswordRequired: FSUPasswordRequiredReducer
})

export default Reducer
